document.addEventListener("DOMContentLoaded", function () {
    var decrementButtons = document.querySelectorAll('.quantity-decrement');
    var incrementButtons = document.querySelectorAll('.quantity-increment');

    decrementButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
            var input = this.parentNode.querySelector('.product-form__quantity-input');
            var currentValue = parseInt(input.value) || 1;
            var min = parseInt(input.getAttribute('min')) || 1;
            if (currentValue > min) {
                input.value = currentValue - 1;
            }
        });
    });

    incrementButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
            var input = this.parentNode.querySelector('.product-form__quantity-input');
            input.value = parseInt(input.value) + 1;
        });
    });
});